export const TABS = ['PLAY','SESSIONS','PLAYERS','FLOW','ROOM','HISTORY'];
export const RACE_MODES = ['CASUAL_COUNTER','FOCUSED_RACE','PRACTICE_SET','FRIEND_MATCH'];
export const SCORE_MODES = ['RACE_TO_TARGET','OPEN_RACK_COUNTER','PRACTICE_RACKS'];
export const CUE_MODES = ['CLASSIC','EIGHT_BALL','NINE_BALL','TEN_BALL','THREE_CUSHION','CUSTOM'];
export const SCORING_STYLES = ['RACKS','POINTS_RACE','INNINGS'];
export const SYNC_MODES = ['LOCAL_ONLY','HOST_CONTROL','SHARED_CONTROL','CONFIRM_SCORES'];
export const TIMER_STYLES = ['OFF','GENTLE_RHYTHM','FOCUS_TIMER','PRESSURE_TIMER'];
export const BALANCE_MODES = ['EVEN','STARTING_SCORE','DIFFERENT_TARGETS','CUSTOM_NOTE'];
export const TURN_RULES = ['WINNER_STAYS','LOSER_BREAKS','MANUAL'];
export const PRIVACY_MODES = ['FULL_PROFILE','MATCH_ONLY','SCORE_ONLY'];
export const POCKETS = ['NONE','TOP_LEFT','TOP_SIDE','TOP_RIGHT','BOTTOM_LEFT','BOTTOM_SIDE','BOTTOM_RIGHT'];
export const GROUPS = ['OPEN','SOLIDS','STRIPES'];

export const label = value => String(value || '').replaceAll('_',' ').toLowerCase().replace(/\b\w/g,c=>c.toUpperCase());
export const clamp = value => Math.max(0, Number(value || 0));
export const nowEvent = (type, side='NONE', state={}, message='') => ({
  type, side, scoreA:clamp(state.scoreA), scoreB:clamp(state.scoreB), message, createdAt:Date.now()
});
export const targetFor = (race, side) => {
  if (race.scoreMode === 'OPEN_RACK_COUNTER') return Number.MAX_SAFE_INTEGER;
  if (race.scoreMode === 'PRACTICE_RACKS') return Math.max(1, Number(race.rackTarget || 10));
  return Math.max(1, Number(side === 'PLAYER_A' ? race.raceToA : race.raceToB) || 5);
};
export const timerDurationFor = flow => {
  const style = flow?.timerStyle || 'OFF';
  if (style === 'OFF') return 0;
  if (style === 'GENTLE_RHYTHM') return 60;
  if (style === 'FOCUS_TIMER') return 45;
  if (style === 'PRESSURE_TIMER') return 30;
  return Math.max(5, Math.min(180, Number(flow?.timerDurationSeconds || 30)));
};
export const restartShotClock = (flow={}, running=true, startedAt=Date.now()) => {
  const duration = timerDurationFor(flow);
  return {
    ...flow,
    timerDurationSeconds: duration,
    timerRemainingSeconds: duration,
    timerRunning: Boolean(running && duration > 0),
    timerStartedAtMs: duration > 0 ? startedAt : null,
  };
};
export const holdShotClock = (flow={}, remaining=flow?.timerRemainingSeconds) => ({
  ...flow,
  timerRemainingSeconds: Math.max(0, Number(remaining || 0)),
  timerRunning: false,
  timerStartedAtMs: null,
});
export const usesInnings = race => race?.cueMode === 'THREE_CUSHION' || race?.scoringStyle === 'INNINGS' || race?.scoringStyle === 'POINTS_WITH_INNINGS';
export const usesPoints = race => usesInnings(race) || race?.scoringStyle === 'POINTS_RACE' || race?.scoringStyle === 'POINTS';
export const otherSide = side => side === 'PLAYER_A' ? 'PLAYER_B' : side === 'PLAYER_B' ? 'PLAYER_A' : 'NONE';
export const averageFor = (race, side) => {
  const s = side === 'PLAYER_A' ? 'A' : 'B';
  const innings = clamp(race?.[`innings${s}`]);
  return innings > 0 ? clamp(race?.[`score${s}`]) / innings : 0;
};
export const pressureState = race => {
  const a=clamp(race.scoreA), b=clamp(race.scoreB), ta=targetFor(race,'PLAYER_A'), tb=targetFor(race,'PLAYER_B');
  if(race.status==='COMPLETED') return 'COMPLETED';
  if(a===ta-1&&b===tb-1) return 'HILL_HILL';
  if(a===ta-1||b===tb-1) return 'ON_THE_HILL';
  if(a/ta>.7||b/tb>.7) return 'FINAL_STRETCH';
  if(Math.abs(a-b)>=3) return a>b?'PLAYER_A_LEADING':'PLAYER_B_LEADING';
  if(a+b<2) return 'OPENING';
  return 'NORMAL';
};
export const gamePreset = cueMode => {
  switch (cueMode) {
    case 'THREE_CUSHION': return { cueMode, scoringStyle:'INNINGS', scoreMode:'RACE_TO_TARGET', raceToA:40, raceToB:40, pointValue:1 };
        default: return { cueMode, scoringStyle:'RACKS', scoreMode:'RACE_TO_TARGET', raceToA:5, raceToB:5, pointValue:1 };
  }
};
export const defaultRace = ({uid,name,photoUrl}) => ({
  createdBy:uid, participantUids:[uid], acceptedUids:[uid], scorekeeperUid:uid,
  mode:'CASUAL_COUNTER', scoreMode:'RACE_TO_TARGET', cueMode:'CLASSIC', scoringStyle:'RACKS', status:'LIVE',
  playerA:{uid,name:name||'Player 1',photoUrl:photoUrl||'',subtitle:'Host',isGuest:false},
  playerB:{uid:null,guestId:`guest_${Date.now()}`,name:'Player 2',photoUrl:'',subtitle:'Guest',isGuest:true},
  playerAName:name||'Player 1', playerBName:'Player 2', playerAUid:uid, playerBUid:'',
  scoreA:0,scoreB:0,recordedRaceScoreA:0,recordedRaceScoreB:0,resultRecorded:false,
  raceTo:5,raceToA:5,raceToB:5,rackTarget:10,raceWinsA:0,raceWinsB:0,
  modeStepsA:0,modeStepsB:0,eightBallGroupA:'OPEN',eightBallGroupB:'OPEN',lastPocket:'NONE',nextObjectBall:1,
  inningsA:0,inningsB:0,currentRunA:0,currentRunB:0,highRunA:0,highRunB:0,pointValue:1,
  highestPointValueA:0,highestPointValueB:0,scoringActionsA:0,scoringActionsB:0,
  doublesEnabled:false,playerAPartnerName:'',playerBPartnerName:'',currentShooterA:'FIRST',currentShooterB:'FIRST',
  activeSide:'NONE',matchBalance:{mode:'EVEN',playerAStartScore:0,playerBStartScore:0,raceToA:5,raceToB:5,rackTarget:10,note:''},
  flow:{timerStyle:'OFF',timerDurationSeconds:0,timerRemainingSeconds:0,timerRunning:false,timerStartedAtMs:null,autoRestartShotTimer:true,matchElapsedSeconds:0,matchClockRunning:false,soundEnabled:true,visualPulseEnabled:true,pressureCuesEnabled:true,keepScreenAwake:false},
  display:{privacy:'FULL_PROFILE',flipHorizontal:false,showPhotos:true,showPlayerStyles:true,showFocusCue:true,showRecentEvents:true,showTimer:true,highContrast:true,largeTextMode:true,keepScreenAwake:true,lockLandscape:false},
  tableTurnRule:'WINNER_STAYS',syncMode:'LOCAL_ONLY',pendingScoreAction:null,isPaused:false,pauseReason:'BREAK',events:[],undoStack:[]
});
export function snapshot(race){
  const keys=['scoreA','scoreB','raceWinsA','raceWinsB','modeStepsA','modeStepsB','inningsA','inningsB','currentRunA','currentRunB','highRunA','highRunB','activeSide','nextObjectBall','eightBallGroupA','eightBallGroupB','flow','status','winnerSide','winnerName'];
  return Object.fromEntries(
    keys
      .filter(key => race[key] !== undefined)
      .map(key => [key, race[key]])
  );
}
export function applyScore(race, side, delta=1){
  const suffix=side==='PLAYER_A'?'A':'B'; const scoreKey=`score${suffix}`; const runKey=`currentRun${suffix}`; const highKey=`highRun${suffix}`;
  const actionKey=`scoringActions${suffix}`; const highestKey=`highestPointValue${suffix}`; const stepKey=`modeSteps${suffix}`;
  // Production scoring follows the mobile model: one tap records one point/rack.
  const scoreDelta=delta;
  const next={...race,undoStack:[...(race.undoStack||[]).slice(-49),snapshot(race)]};
  next[scoreKey]=clamp(next[scoreKey]+scoreDelta); next[actionKey]=clamp(next[actionKey]+(delta>0?1:-1)); next[stepKey]=clamp(next[stepKey]+(delta>0?1:-1));
  next[runKey]=delta>0?clamp(next[runKey]+1):Math.max(0,clamp(next[runKey])-1); next[highKey]=Math.max(clamp(next[highKey]),next[runKey]); next[highestKey]=Math.max(clamp(next[highestKey]),1);
  if(delta>0){
    next.activeSide=side;
    if(race.cueMode==='NINE_BALL')next.nextObjectBall=next.nextObjectBall>=9?1:next.nextObjectBall+1;
    if(race.cueMode==='TEN_BALL')next.nextObjectBall=next.nextObjectBall>=10?1:next.nextObjectBall+1;
    // Every recorded score represents a completed shot. In point/inning games the shooter continues,
    // but receives a fresh clock for the next shot. Rack games also receive a fresh clock for the next turn.
    if (next.flow?.autoRestartShotTimer !== false) next.flow=restartShotClock(next.flow,!next.isPaused);
  }
  const target=targetFor(next,side); if(next[scoreKey]>=target&&race.scoreMode!=='OPEN_RACK_COUNTER'){
    next.status='COMPLETED';next.winnerSide=side;next.winnerName=side==='PLAYER_A'?race.playerAName:race.playerBName;next.flow=holdShotClock(next.flow,0);
  }
  next.events=[...(race.events||[]).slice(-79),nowEvent(delta>0?'SCORE_ADDED':'SCORE_REMOVED',side,next,`${side==='PLAYER_A'?race.playerAName:race.playerBName} ${delta>0?'scored':'score removed'}`)];
  return next;
}
export function endInning(race, side=race?.activeSide){
  if (!race || !side || side === 'NONE') return race;
  const s=side==='PLAYER_A'?'A':'B';
  const nextSide=otherSide(side);
  const next={...race,undoStack:[...(race.undoStack||[]).slice(-49),snapshot(race)]};
  next[`innings${s}`]=clamp(next[`innings${s}`]+1);
  next[`currentRun${s}`]=0;
  next.activeSide=nextSide;
  next.status='LIVE';
  next.flow=restartShotClock(next.flow,!next.isPaused);
  next.events=[...(race.events||[]).slice(-79),nowEvent('INNING_ADDED',side,next,`${side==='PLAYER_A'?race.playerAName:race.playerBName} ended the inning`)];
  return next;
}
export function recordFoul(race, side=race?.activeSide){
  if (!race || !side || side === 'NONE') return race;
  const next=endInning(race,side);
  next.events=[...(next.events||[]).slice(-79),nowEvent('FOUL',side,next,`${side==='PLAYER_A'?race.playerAName:race.playerBName} committed a foul`)];
  return next;
}
export function undoRace(race){const stack=[...(race.undoStack||[])];const previous=stack.pop();if(!previous)return race;return {...race,...previous,undoStack:stack,events:[...(race.events||[]).slice(-79),nowEvent('UNDO','NONE',previous,'Last action undone')]};}
export function formatClock(total){const s=Math.max(0,Number(total||0));return `${String(Math.floor(s/60)).padStart(2,'0')}:${String(s%60).padStart(2,'0')}`;}
